import { render, staticRenderFns } from "./FilesTable.vue?vue&type=template&id=b228dd1a&scoped=true&"
import script from "./FilesTable.vue?vue&type=script&lang=js&"
export * from "./FilesTable.vue?vue&type=script&lang=js&"
import style0 from "./FilesTable.vue?vue&type=style&index=0&id=b228dd1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b228dd1a",
  null
  
)

export default component.exports